import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { DataIoService } from '../../../../services/data-io.service';
import { BaseSensor } from '../../../../classes';
import { IconbarComponent } from './iconbar/iconbar.component';
@Component({
	selector: 'app-statusbar',
	templateUrl: './statusbar.component.html',
	styleUrls: ['./statusbar.component.scss']
})
export class StatusbarComponent implements OnInit {
	outdoorTempSensor:BaseSensor;
	indoorTempSensor:BaseSensor;
	humiditySensor:BaseSensor;
	debug : boolean = false;
	getIoService(){
		return this.ioService;
	}
	hasOutdoorSensor(){
		let sc = this.ioService.getConfiguration().simulatorConfig;
		if(sc.witterungsgefuehrt()){
			return false;
		}
		return !( sc.isStandalone() || sc.hasSensoDIRECT()||sc.hasControl() );
	}
	constructor(private ioService: DataIoService) {
		this.debug = (!environment.production);
		
		this.outdoorTempSensor = this.ioService.sensors.getTemperatureSensor('outdoor');
		this.indoorTempSensor = this.ioService.sensors.getTemperatureSensor('room_temperature');
		this.humiditySensor = this.ioService.sensors.getHumiditySensor('humidity');
		
	}

	ngOnInit() {
	}

}
